'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { Drawer, IconButton } from '@/shared/components/ui';
import { FeatherX } from '@subframe/core';
import type { ColunaDisponivel } from '@/features/negociacaoColunas';
import type { Flow } from '@/features/negociacaoIndividualWizard';
import type { NegociacaoSituacaoSummary } from '@/features/negociacoes';
import type { NegociacaoCasoTelefoneUi } from '../../types/negociacaoDetailTypes';
import type { IaStatusUi, NegotiationDetails } from '../../types/negociacaoDetailUiTypes';
import { NegociacaoDetailSidebarContent } from './NegociacaoDetailSidebarContent';
export interface NegociacaoDetailSidebarProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  negotiation: NegotiationDetails;
  colunasExtras: ColunaDisponivel[];
  flow: Flow | null;
  isFlowLoading: boolean;
  iaStatusUi: IaStatusUi;
  isIAPaused: boolean;
  isReadOnly: boolean;
  canToggleAutomation: boolean;
  isToggleAutomationLoading: boolean;
  isStartPending: boolean;
  isStartFailed: boolean;
  isStartCancelled: boolean;
  agentInput: Record<string, unknown> | null;
  onToggleAutomationClick: () => void;
  getTemperatureColorClass: (temp: string) => string;
  situacoes: NegociacaoSituacaoSummary[];
  telefones: NegociacaoCasoTelefoneUi[];
  telefonesLoading: boolean;
  telefonesError: string | null;
  onCarregarTelefones: () => void;
}
export function NegociacaoDetailSidebar(props) {
  const $ = _c(21);
  const [section, setSection] = useState("dados");
  let t0;
  if ($[0] !== props || $[1] !== section) {
    t0 = <NegociacaoDetailSidebarContent {...props} section={section} onSectionChange={setSection} />;
    $[0] = props;
    $[1] = section;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const content = t0;
  let t1;
  if ($[3] !== content) {
    t1 = <aside aria-label={"Detalhes da negocia\xE7\xE3o"} className="hidden h-full w-72 shrink-0 border-l border-neutral-100 min-[1280px]:block">{content}</aside>;
    $[3] = content;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <h2 className="text-body-bold font-body-bold">Detalhes da negociação</h2>;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FeatherX />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== props) {
    t4 = <div className="flex w-full shrink-0 items-center justify-between border-b border-neutral-100 px-4 py-3">{t2}<IconButton aria-label="Fechar detalhes" variant="neutral-tertiary" icon={t3} onClick={() => props.onOpenChange(false)} /></div>;
    $[7] = props;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== content) {
    t5 = <div className="min-h-0 w-full flex-1">{content}</div>;
    $[9] = content;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <Drawer.Content aria-label={"Detalhes da negocia\xE7\xE3o"} aria-describedby={undefined} onCloseAutoFocus={_temp} className="w-[380px] max-w-[100vw] min-w-0">{t4}{t5}</Drawer.Content>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== props.onOpenChange || $[15] !== props.open || $[16] !== t6) {
    t7 = <Drawer title={"Detalhes da negocia\xE7\xE3o"} open={props.open} onOpenChange={props.onOpenChange}>{t6}</Drawer>;
    $[14] = props.onOpenChange;
    $[15] = props.open;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t1 || $[19] !== t7) {
    t8 = <>{t1}{t7}</>;
    $[18] = t1;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}
function _temp(event) {
  event.preventDefault();
  document.getElementById("negociacao-detalhes-trigger")?.focus();
}